import { axios } from 'data';
import { Withdrawal } from 'types/models';
import { WithdrawalParams } from 'types/services';

const getWithdrawal = async () => {
  const response = await axios.get<Withdrawal>('/withdrawal');

  return response.data;
};

const updateWithdrawal = async (params: WithdrawalParams) => {
  await axios.patch<never>('/withdrawal', params);
};

const withdrawalService = {
  getWithdrawal,
  updateWithdrawal,
};

export default withdrawalService;
